import { zodResolver } from '@hookform/resolvers/zod'
import { useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { CartContext } from '../../Cart.vm'

type FormValues = {
    email: string
}
export const useViewModel = () => {
    const {
        cartActor: [state, send],
    } = useContext(CartContext)
    
    const emailAlreadyExists = state.context.options.email_already_exists 
    const form = useForm<FormValues>({
        defaultValues: {
            email: '',
        },
        resolver: zodResolver(
            z.object({
                email: z.string().email("L'email n'est pas valide."),
            }),
        ),
    })

    const onSubmit = form.handleSubmit((data: FormValues) => {
        if (!data) return

        send({
            type: 'UPDATE_ANONYMOUS_EMAIL',
            updatedAnonymousEmail: data.email,
        })
    })

    useEffect(() => {
        if (
            !state.context.options.anonymous_mode ||
            !state.context.options.anonymous_email
        ) {
            return
        }

        if (!form.formState.isSubmitted) {
            return
        }

        // ? Go to CHECKOUT.INITIALIZING to create a new cart for an anonymous user
        send({ type: 'NEXT' })
    }, [form.formState, send, state.context])

    return {
        form,
        onSubmit,
        send,
        emailAlreadyExists
    }
}
